<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('xyf.title')}}</div>
        </div>
        <div class="cotainer">
            <div class="credit-box" v-show="credit">
                <div class="text t1">{{$t('xyf.title')}}</div>
                <div class="GaugeMeter" id="PreviewGaugeMeter_2" data-percent="10" data-append="" data-size="250" data-theme="#2CAADE" data-back="RGBa(0,0,0,.1)" data-animate_gauge_colors="1" data-animate_text_colors="1" data-width="10" data-label="" data-style="Full" data-label_color="#fff"></div>
                <div class="text t2">{{credit_name}}</div>
                <div class="text t3">{{$t('xyf.pgsj')}}</div>
                <div class="text t4">{{credit_time}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import '../utils/jquery.AshAlom.gaugeMeter-2.0.0.min.js'
export default {
    name: 'credit',
    data () {
        return {
            token: '',
            credit: '',
            credit_name: '',
            credit_time: '',
            theme: false
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        back(){
            this.$router.push('/user')
        },
        getInfo(){
            let params = {
               token: this.token
            }
            this.$ajax.get('/web/info',{params}).then((res) => {
                let resData = res.data.data;
                this.credit = resData.credit;
                this.credit_name = resData.credit_name;
                this.credit_time = resData.credit_time;
                $('.GaugeMeter').attr('data-percent',resData.credit);
                $(".GaugeMeter").gaugeMeter();
            }).catch(function(err){
                console.log(err)
            })
        }
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .credit-box{
        position: relative;
        padding: 80px 0 0;
        color: #7f7f7f;
        font-size: 13px;
    }
    .credit-box .text{
        position: absolute;
        width: 100%;
        color: #000;
        text-align: center;
    }
    .credit-box .t1{
        top: 150px
    }
    .credit-box .t2{
        bottom: 85px
    }
    .credit-box .t3{
        bottom: 60px;
        font-size: 12px;
    }
    .credit-box .t4{
        bottom: 42px;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/credit.vue